// extracted by mini-css-extract-plugin
module.exports = {"heading":"_2a4b5","heading__body":"_95375","headingBody":"_95375","heading__body__title":"ba649","headingBodyTitle":"ba649"};